import React from 'react';
import image from '../images/logo.png';
import style from '../css/Component2.module.css';
import useLocation from './useLocation';

function Four() {
		const location = useLocation();  
	return (
		<div className={style.container}>
			<img
				style={{ backgroundColor: '#8cb89f',borderRadius:20 }}
				src={image}
				alt=""
				className={style.image}
			/>

			<div className={style.box}>
				<h1 className={style.header}>About Us!</h1>
				<p className={style.desc}>
					HomeTech Repairs, we specialize in providing fast, reliable, and
					affordable home appliance repair services in {location}. From
					washing machines to air conditioners, our expert technicians work
					diligently to restore your appliances to optimal performance with
					minimal downtime. HomeTech Repairs – Bringing Life Back to Your
					Appliances.
				</p>
			</div>
		</div>
	);
}

export default Four;
